import { Facebook, Instagram, Twitter } from "lucide-react";
import React from 'react';
import { useSelector } from "react-redux";

const AssessmentFooter = () => {
  // Get the company data from localStorage
  const companyData = useSelector((state) => state.companyReducer.company);
  const companyDetails = companyData ? JSON.parse(companyData) : null;

  // Contact info from companyDetails
  const number = companyDetails?.contactPerson?.phoneNumber || "244-5333-7783";
  const code = companyDetails?.contactPerson?.countryCode || "+1";
  const phoneNumber = `${code} ${number}`;
  const email = companyDetails?.contactPerson?.email || "avpstech.com";

  // Social Media Links (always show these specific platforms)
  const socialLinks = [
    {
      name: "facebook",
      IconComponent: Facebook,
      url: companyDetails?.socialMediaAccounts?.find(account => account.name.toLowerCase() === "facebook")?.value || "https://www.facebook.com",
      colorClass: "text-blue-800",
    },
    {
      name: "instagram",
      IconComponent: Instagram,
      url: companyDetails?.socialMediaAccounts?.find(account => account.name.toLowerCase() === "instagram")?.value || "https://www.instagram.com",
      colorClass: "text-pink-500",
    },
    {
      name: "twitter",
      IconComponent: Twitter,
      url: companyDetails?.socialMediaAccounts?.find(account => account.name.toLowerCase() === "twitter")?.value || "https://www.twitter.com",
      colorClass: "text-blue-700",
    },
  ];

  return (
    <footer className="bg-[rgb(8,64,88)] py-6 text-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">

          {/* Social Media Links */}
          <div>
            <h6 className="font-bold text-lg mb-2 text-white">Follow Us</h6>
            <div className="flex space-x-2">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`hover:bg-gray-100 rounded-full p-2 transition ${social.colorClass}`}
                >
                  <social.IconComponent size={28} strokeWidth={1.8} aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h6 className="font-bold text-lg mb-2 text-white">Quick Links</h6>
            <div className="flex flex-col space-y-2">
              <button type="button" className="text-white flex items-center hover:underline bg-transparent border-0 p-0 text-left">
                Help
              </button>
              <button type="button" className="text-white flex items-center hover:underline bg-transparent border-0 p-0 text-left">
                Share
              </button>
              <button type="button" className="text-white flex items-center hover:underline bg-transparent border-0 p-0 text-left">
                Careers
              </button>
            </div>
          </div>

          {/* Contact Information */}
          <div>
            <h6 className="font-bold text-lg mb-2 text-white">Contact</h6>
            <div className="flex flex-col space-y-2">
              <span className="text-white flex items-center">
                {phoneNumber}
              </span>
              <a href={`mailto:${email}`} className="text-white flex items-center hover:underline">
                {email}
              </a>
            </div>
          </div>

          {/* Legal Links */}
          <div>
            <h6 className="font-bold text-lg mb-2 text-white">Legal</h6>
            <div className="flex flex-col space-y-2">
              <button type="button" className="text-white flex items-center hover:underline bg-transparent border-0 p-0 text-left">
                Terms & Conditions
              </button>
              <button type="button" className="text-white flex items-center hover:underline bg-transparent border-0 p-0 text-left">
                Privacy Policy
              </button>
            </div>
          </div>
        </div>

        <hr className="my-4" />

        <p className="text-center text-gray-300 text-sm">
          © {new Date().getFullYear()} AVPS Academy. All rights reserved.
        </p>
        <p className="text-center text-gray-300 mt-1">
          <strong>Powered by</strong>{" "}
          <img
            loading="lazy"
            src="https://www.krumago.com/logo.png"
            alt="Krumago"
            className="max-h-6 inline-block align-middle ml-1 cursor-pointer"
          />
          <br />
          <a
            href="https://www.krumago.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 hover:underline"
          >
            www.krumago.com
          </a>
        </p>
      </div>
    </footer>
  );
};

export default AssessmentFooter;
